/* Ott-common */
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import { getDeviceInfo, isVidaa } from './general';
import { MsToWaitOnReconnection, Platform } from '../../constants';
import vkKeys from '../common/vkKeys';

function init() {}

export default {
  osName: 'VIDAA',
  platformName: 'HiSense',
  isVidaa: true,
  signupUrl: '/vidaa',
  appName: 'hisense_tv',
  aemPlatform: AemPlatform.HISENSE,
  isThisPlatform: isVidaa,
  init,
  // App and device info
  getDeviceInfo,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.HISENSE],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  // Conviva
  npaw: {
    name: 'Hisense',
  },
  // Key codes
  keyCodes: {
    ...vkKeys,
    back: window.VK_BACK_SPACE,
  },
  getAppVersion: () => '',
};
